module.exports = __webpack_public_path__ + "components/modal-app-popup/static/caret-right-icon-af493b910651adccbe205e14125eb46a.svg";